<template>
  <section
    id="about"
    class="co-bg-striped"
  >
    <div class="co-container-lg px-4 py-20 text-left md:text-center">
      <h2 class="co-display-7 mb-8 text-center">
        <slot name="title">
          タイトルが入ります
        </slot>
      </h2>
      <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
        <slot name="text">
          テキストが入りますテキストが入りますテキストが入ります
          <br>
          テキストが入りますテキストが入りますテキストが入ります
          <br>
          テキストが入りますテキストが入りますテキストが入ります
          <strong class="text-co-danger-500">
            テキストが入ります
          </strong>
          <br>
          テキストが入りますテキストが入りますテキストが入ります
          <br>
          テキストが入りますテキストが入りますテキストが入ります
        </slot>
      </p>
    </div>
  </section>
</template>
